import { render, staticRenderFns } from "./UploadProjectFile.vue?vue&type=template&id=65623378&scoped=true&lang=html"
import script from "./UploadProjectFile.vue?vue&type=script&lang=js"
export * from "./UploadProjectFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65623378",
  null
  
)

export default component.exports